import React from 'react'
import { Box, Typography } from '@mui/material'
import { Lock as LockIcon } from '@mui/icons-material'
import { AisleCell } from '../types'
import { ViewMode, CELL_ALPHA } from '../config/constants'
import { resolveCellVisual, withAlpha } from '../config/utils'
import { mapCellStyles as styles } from '../styles/MapCell.styles'
import { slotMarkerSx } from '../styles/shared.styles'
import { MAP_CELL_ATTR } from '../hooks/useCellSummary'


export const AisleMapCell = React.memo(function AisleMapCell({
  cell,
  cellKey,
  size,
  brandColors,
  zoneColors,
  mode,
  highlightBrand = null,
  isSummaryOpen = false,
  onClick,
  onDoubleClick,
}: {
  cell: AisleCell
  cellKey: string
  size: number
  brandColors: Map<string, string>
  zoneColors: Map<string, string>
  mode: ViewMode
  highlightBrand?: string | null
  isSummaryOpen?: boolean
  /** Click simple: muestra el resumen. Recibe el nodo para anclar el Popper. */
  onClick?: (cellKey: string, anchorEl: HTMLElement) => void
  /** Doble click: abre el detalle. El padre decide si la celda lo admite. */
  onDoubleClick?: (cellKey: string) => void
}) {
  const { bg, text, textColor } = resolveCellVisual(cell, mode, brandColors, zoneColors)

  const isBlocked = cell.blockType !== 'none'
  const isDimmed = highlightBrand !== null && !cell.brands.some((b) => b.name === highlightBrand)

  return (
    <Box
      {...{ [MAP_CELL_ATTR]: true }}
      onClick={onClick ? (e) => onClick(cellKey, e.currentTarget) : undefined}
      onDoubleClick={onDoubleClick ? () => onDoubleClick(cellKey) : undefined}
      sx={styles.cell({
        size,
        background: withAlpha(bg, CELL_ALPHA),
        isDimmed,
        isSummaryOpen,
        hoverBrightness: 1.1,
      })}
      >
        {text !== null && (
          <Typography variant='caption' sx={styles.stockText(textColor)}>
            {text}
          </Typography>
        )}
        {isBlocked && (
          <LockIcon
            sx={styles.lockIcon(
              textColor === '#fff' ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.4)'
            )}
          />
        )}
        {cell.hasSlots && <Box sx={slotMarkerSx(8)} />}
    </Box>
  )
})
